const useVersion = () => {
  return {
    version: '1.0.25',
  }
}

export default useVersion;
